module.exports = __webpack_public_path__ + "static/media/joyable8_preview.d59501fc.jpg";